import script from "./History.vue?vue&type=script&setup=true&lang=ts"
export * from "./History.vue?vue&type=script&setup=true&lang=ts"

import "./History.vue?vue&type=style&index=0&id=ec9a2fa8&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec9a2fa8"]])

export default __exports__